import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.PricingLimitTemplate.List.IRequest;
type Response = Api.Core.PricingLimitTemplate.List.IResponse;
type Headers = Api.Core.PricingLimitTemplate.List.IHeaders;
const url = '/api/ProductManagement/PricingLimitTemplate';
export default async function pricingLimitTemplateListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
